import { marked } from 'marked';
import DOMPurify from 'dompurify';

export const parseMarkdownToHtml = (markdownText) => {
    // Configure the `marked` parser (optional)
    marked.setOptions({
        breaks: true, // Convert line breaks to <br>
        gfm: true,    // GitHub-flavored markdown
    });

    const rawHtml = marked(markdownText); // Convert markdown to HTML
    return DOMPurify.sanitize(rawHtml); // Sanitize the HTML
};
